import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/',
    exact: true,
    name: 'admin_settings',
    component: loadableWithRetry(() => import('./SettingContainer')),
  },
]

export default routes
